import React from 'react';
import classNames from 'classnames';
import { AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { CNavLink } from './c/CHeader';
import NotificationBar from "./NotificationBar";
import ExamSwitcher from "./ExamSwitcher";
import ExamsBookHeaderLogo from "../../../assets/images/examsbook-logo.png";
import { useIsPremiumUser } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from "react-router-dom";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import { useSelector } from "react-redux";
import LanguageSwitcher from "./LanguageSwitcher";

function CHeaderBarContent(props) {
    const { classes, open, handleDrawerOpen, openFeedbackModel, handleAddHeaderExam } = props;
    const isPremium = useIsPremiumUser();
    const navigate = useNavigate();
    const t = useTranslations();
    const user = useSelector(state => state.user);
    const currentDate = new Date().toISOString();
    const expieryDate = user.premiumExpiry;
    const diff = Math.floor((Date.parse(expieryDate) - Date.parse(currentDate)) / 86400000);
    const appSettings = useSelector((state) => state.appSettings);
    const isPaymentEnabled = !!appSettings.paymentEnabled;
    return (
        <AppBar position="fixed"
                className={classNames(classes.appBar, {
                    [classes.appBarShift]: open,
                })}>
            <Toolbar disableGutters={!open} className="main-header-section">
                <div className="headerLeft">
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={handleDrawerOpen.bind(this)}
                        className={classNames(
                            classes.HeaderMenuButton,
                            open,
                        )}>
                        <MenuIcon/>
                    </IconButton>
                    <Typography className="logo-main" variant="h6" color="inherit" noWrap>
                        <CNavLink to="/my-app/">
                            <img src={ExamsBookHeaderLogo} alt="examsbook logo"/>
                        </CNavLink>
                    </Typography>
                </div>
                <div className="notification-bar">
                    <NotificationBar openFeedbackModel={openFeedbackModel}/>
                    <div className="toggled-menu desk-menu exam-switcher">
                        <ExamSwitcher handleAddHeaderExam={handleAddHeaderExam}/>
                    </div>
                    <div className="mobile-language-header">
                        <ul className="right-menus">
                            <li className="">
                                <LanguageSwitcher/>
                            </li>
                        </ul>
                    </div>
                    {
                        isPaymentEnabled && <div className="toggled-menu desk-menu">{isPremium && (diff <= 7) ?
                            <Button className="renew-plan"
                                    onClick={() => navigate('/my-app/payments')}>{t('RENEW_VIP')}</Button>
                            : isPremium ? <Button className="header-plan">{t('VIP')}</Button>
                                : <Button className="header-become-plan"
                                          onClick={() => navigate('/my-app/payments')}>{t('GET_VIP')}</Button>
                        }
                        </div>
                    }
                </div>
                <div className="search-bar">
                    <ul>
                        <li>
                            <i className="fa fa-search"/>
                        </li>
                        <li>
                            <i className="fa fa-bell"/>
                        </li>
                    </ul>
                </div>
            </Toolbar>
        </AppBar>
    );
}

export default CHeaderBarContent;
